import { render, staticRenderFns } from "./DecastCard.vue?vue&type=template&id=1da53fac&scoped=true&"
import script from "./DecastCard.vue?vue&type=script&lang=js&"
export * from "./DecastCard.vue?vue&type=script&lang=js&"
import style0 from "./DecastCard.vue?vue&type=style&index=0&id=1da53fac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da53fac",
  null
  
)

export default component.exports